import type { ReactNode } from "react";
import { cn } from "@tellescope/design-system";
import { formatName, type Name } from "@tellescope/utils";

export type RelatedContactsListItemContact = Name & {
  id: string;
  email?: string;
};

export type RelatedContactsListItemProps = {
  contact: RelatedContactsListItemContact;
  selected?: boolean;
  onClick?: () => void;
  trailing?: ReactNode;
};

export const RelatedContactsListItem = ({
  contact,
  selected = false,
  onClick,
  trailing,
}: RelatedContactsListItemProps) => {
  const className = cn(
    "w-full text-left p-3 rounded-md transition-colors",
    onClick && "hover:bg-muted",
    selected ? "bg-primary text-primary-foreground hover:bg-primary/90" : "bg-muted/50"
  );

  const content = (
    <div className="flex justify-between items-start gap-2">
      <div className="min-w-0">
        <div className="font-medium truncate text-sm">{formatName(contact)}</div>
        {contact.email && (
          <div className={cn("text-xs truncate", selected ? "text-primary-foreground/70" : "text-muted-foreground")}>
            {contact.email}
          </div>
        )}
      </div>
      {trailing && (
        <div className={cn("text-xs font-medium shrink-0", selected ? "text-primary-foreground" : "text-primary")}>
          {trailing}
        </div>
      )}
    </div>
  );

  return onClick ? (
    <button onClick={onClick} className={className} data-testid="contact-details-block-item">
      {content}
    </button>
  ) : (
    <div className={className} data-testid="contact-details-block-item">
      {content}
    </div>
  );
};
